import { useEffect, useState, useRef } from 'react'
import TextBoxControl from '../../Controls/TextBoxControl';
import ButtonControl from "../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../assets/css/Login.css"
import {
    SetLocal,
    ClearLocal,
    FetchService,
    IsValidNationalCode,
    IsEmptyString,
    IsEmptyInput,
    Base64Type
} from "../../Base/BaseControl";
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';


let FileExt = '';
export default function Index({ Click, page }) {
    const textBoxFileNumberRef = useRef(null);
    const textBoxLetterNumberRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [getPdf, setPdf] = useState('');

    const navigate = useNavigate();
    //const [nationalCode, checkNationalCode] = useState(true);

    useEffect(() => {

    }, []);

    const validateLetterSubmit = () => {
        if (IsEmptyInput(textBoxFileNumberRef))
            return false;

        if (IsEmptyInput(textBoxLetterNumberRef))
            return false;


        var inputValue = {
            FileNumber: Number(textBoxFileNumberRef.current.value),
            LetterNumber: Number(textBoxLetterNumberRef.current.value),
        };
        FetchService("General/ValidateLetter", inputValue, validateLetterSubmitSuccess);
    }



    const validateLetterSubmitSuccess = (ServiceResult) => {
        setPdf("data:application/pdf;base64," + ServiceResult);
        setShowModal(true)


    }
 


    return (
        <div id="bglogin">
            <div className="main">
                <div className="formLogin">
                    <div>
                        <TextBoxControl
                            inputRef={textBoxFileNumberRef}
                            title="شماره پرونده:"
                            required={true}
                            placeholder="شماره پرونده خود را وارد نمایید"
                        />

                        <TextBoxControl
                            inputRef={textBoxLetterNumberRef}
                            title="شماره نامه:"
                            required={true}
                            placeholder="شماره نامه خود را وارد نمایید"
                        />



                        <ButtonControl
                            onClick={validateLetterSubmit}
                            variant="primary"
                            title="تایید"
                        />

                        <ButtonControl
                            onClick={() => navigate("/")}
                            variant="danger mx-2"
                            title="بازگشت"
                        />
                    </div>
                </div>
            </div>
            <Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowModal(false)}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}